var kosan = kosan || {};

kosan.accordion = new function () {

    this.init = function () {
        // Get the width of the window for the faq elemnt
        var $window = $(window);
        var windowsize = $window.width();
        function checkWidth() {
            if (windowsize > 1000) {
                //if the window is greater than 1000px then tranform to the desktop version
                $(".faq-block").css({
                    "width": "40%",
                    "float":"left"
                });
                $('.faq-content').toggle();
            } else {
                $(".faq-block").css({
                    "width": "100%",
                    "float": "none"
                });
                $('.faq-content').toggle();
            }
        }

        // Execute on load
        checkWidth();

        $('.accordion-element').on('click', function () {
			if (windowsize > 1000) {
			    var guid = "#" + $(this).data("guid");
			    $('html, body').animate({
			        scrollTop: $(guid).offset().top - $(".header-bottom").height() - $(".header-top").height() - 130
			    }, 500);
		        if ($(this).hasClass("selected")) {
		            $(this).removeClass("selected");
		            $('.faq-content').html("<h4></h4>");
		        } else {
		            $('.accordion-element').removeClass("selected");
		            $('.faq-content').html("<h4></h4>");
		            $(this).addClass("selected");
		            $(guid + "> h4").append($(this).find("h4").text());
		            $(guid).append($(this).find(".accordion-item").html());
					$(".faq-content").css("display", "block");
		        }
		    } else {
		        if ($(this).hasClass("active")) {
		            $(this).removeClass("active");
		        } else {
		            $('.accordion-element').removeClass("active");
		            $('.faq-content').html("<h4></h4>");
		            $(this).addClass("active");
		        }
		    }
		});


	}
};
